import { createAction } from 'typesafe-actions';

import { EDealType } from 'shared/types/filters';

export const changeDealTypeAction = createAction('filters/dealTypeChanged')<EDealType>();
